import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'FormatDateHour',
  standalone: true
})
export class FormatOtherDateHourPipe implements PipeTransform {

    transform(date: string | Date, includeTime: boolean = false): string {
        if (date) {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();

        if (includeTime) {
            const hours = d.getHours().toString().padStart(2, '0');
            const minutes = d.getMinutes().toString().padStart(2, '0');
            const seconds = d.getSeconds().toString().padStart(2, '0');
            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        }
        return `${day}-${month}-${year}`;
        }
        return '--:--:--';
    }

    formatHour(date: string | Date): string {
        if (date) {
            const d = new Date(date);
            const hours = d.getHours().toString().padStart(2, '0');
            const minutes = d.getMinutes().toString().padStart(2, '0');
            const seconds = d.getSeconds().toString().padStart(2, '0');
            return `${hours}:${minutes}:${seconds}`;
        }
        return '--:--:--';
    }
}
